import {AuthDialogData} from 'app/reducers/authDialogReducer';

export function updateAuthDialogData(data: AuthDialogData) {
  return {
    type: 'UPDATE_AUTH_DIALOG_DATA',
    data,
  };
}

export function closeAuthDialog() {
  return {
    type: 'CLOSE_AUTH_DIALOG',
  };
}
